import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { AppFeature } from "../types/AppFeature";

export interface AppFeaturesState {
    hasSuccessfullyFetchedFeatures: boolean;
    enabledFeaturesErrorResponse: FetchBaseQueryError | undefined;
    enabledFeatures: Record<AppFeature, string | undefined>;
}

export const initialState: AppFeaturesState = {
    hasSuccessfullyFetchedFeatures: false,
    enabledFeaturesErrorResponse: undefined,
    enabledFeatures: {} as Record<AppFeature, string | undefined>,
};
